export default __webpack_public_path__ + "static/media/nft2.fb555e5d.png";